// Fetch list

export const FETCH = 'reportDispatcherKPI.FETCH'
export const FETCH_STARTED = 'reportDispatcherKPI.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportDispatcherKPI.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportDispatcherKPI.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportDispatcherKPI.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportDispatcherKPI.CLEAR'

// Export

export const EXPORT = 'reportDispatcherKPI.EXPORT'
export const EXPORT_FULFILLED = 'reportDispatcherKPI.EXPORT_FULFILLED'
